@if (inited) {
<sm-toolbar>
    <p-button [disabled]="!isChanged()" icon="fas fa-save" label="Speichern" (onClick)="save()">
    </p-button>
</sm-toolbar>
<p-table [value]="rows" class="p-datatable-gridlines">
    <ng-template pTemplate="header">
        <tr>
            <th width="30%">Klassenamt</th>
            <th width="10%">Ist Schüler</th>
            <th width="30%">Vorsitz</th>
            <th width="30%">Stellvertreter</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-index="rowIndex">
        <tr>
            <td>{{row.type}}</td>
            <td>
                <p-toggleswitch (onChange)="changeIsPupil($event, row.type)" [(ngModel)]="isPupil[row.type]"></p-toggleswitch>
            </td>
            <td pEditableColumn>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        @if (isPupil[row.type]) {
                        <p-select [filter]=true [resetFilterOnHide]="true" [autofocusFilter]="true" id="main" [editable]=false class="width100p" [options]="pupilsGui" [ngModel]="row.main" (ngModelChange)="changeMain($event, row)">
                        </p-select>
                        }
                        @if (!isPupil[row.type]) {
                        <input type="text" class="width100p" pInputText [(ngModel)]="row.mainText" />
                        }
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ row.main != 0 ? getPupil(row.main) : (row.mainText != "" ? row.mainText : '') }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td pEditableColumn>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        @if (isPupil[row.type]) {
                        <p-multiSelect id="substitutes" appendTo="body" selectionMode="multiple" class="width100p" [resetFilterOnHide]="true" [autofocusFilter]="true" [options]="pupilsGuiSubstitute" [ngModel]="row.substitutes" (ngModelChange)="changeSubstitutes($event, row)">
                        </p-multiSelect>
                        }
                        @if (!isPupil[row.type]) {
                        <input type="text" class="width100p" pInputText [(ngModel)]="row.substitutesText" />
                        }
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{row.substitutes != null && row.substitutes.length > 0 ? getPupilList(row.substitutes).join(', ') : (row.substitutesText != "" ? row.substitutesText : '')}}
                    </ng-template>
                </p-cellEditor>
            </td>
        </tr>
    </ng-template>
</p-table>
}
